import React from 'react'
import styled from 'styled-components'
import {_L, useLocaleState} from '../context/LocaleContext'

const Container = styled.div`
  color: #3395fe;
  width: 100%;
  text-align: center;
  padding-top: 16px;
  padding-bottom: 16px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
`

const ShowMore = ({recordCount, onClick, testId}) => {
  const localeState = useLocaleState()

  const doShowMore = recordCount => {
    if (recordCount > 0) {
      onClick()
    }
  }

  return recordCount > 0 ? (
    <Container
      data-testid={testId || 'show-more-container'}
      onClick={() => doShowMore(recordCount)}
    >
      {_L({key: 'Show More', localeState})} {`(${recordCount})`}
    </Container>
  ) : null
}

ShowMore.defaultProps = {
  recordCount: 0
}

export default ShowMore
